import { createNgReactBridgeConstant } from '../../react-bridge'

export const PREFERENCE_PROPERTIES = {
  OVERRIDE_LIBRARY_SCORING: 'library.scoring.type.override',
  LIBRARY_POLICY_FAIL_VIOLATIONS: 'library.policy.fail.violations',
  LIBRARY_SCORING_TYPE: 'library.scoring.type',
  OVERALL_SCORING_TYPE: 'overall.scoring.type',
  OVERALL_SCORING_CUSTOM_LANGUAGES: 'overall.scoring.custom.languages',
  LIBRARY_POLICY_OVERRIDE: 'library.policy.override',
  SAML_ENABLED: 'saml.enabled',
  TSV_ENABLED_OVERRIDE: 'tsv.enabled.override',
  TSV_ENABLED: 'tsv.enabled',
  USERS_IMPORT_USER: 'users.import.user',
  PASSWORD_POLICY_OVERRIDE: 'password.policy.override',
  LICENSE_AUTO_OVERRIDE: 'license.auto.override',
  WILDCARD_ORGANIZATIONS: 'wild.card.organizations'
}

createNgReactBridgeConstant('PREFERENCE_PROPERTIES', PREFERENCE_PROPERTIES)
